<template>
    <div v-if="modal" class="fixed z-50 pin bg-smoke-dark">
        <div class="animated slideInDown fixed z-50 pin overflow-auto flex" @click.self="toggle">
            <div class="bg-white rounded-lg shadow p-6 max-w-3xl md:relative pin-b pin-x align-top m-auto justify-end md:justify-center w-full md:h-auto md:shadow flex flex-col relative">

                <div class="header relative">
                    <h3 class="text-xl font-semibold pb-3 border-b-2 border-grey-lighter mb-6">
                        <slot name="header"></slot>
                    </h3>
                    <button class="text-grey-darkest font-bold rounded absolute top-0 right-0 outline-none text-xl" @click="toggle">
                        <i class="fas fa-times"></i>
                    </button>
                </div>

                <div class="error">
                    <slot name="error"></slot>
                </div>

                <div class="body">
                    <slot name="body"></slot>
                </div>

            </div>

        </div>
    </div>
</template>


<script>
    import { EventBus } from '@/utils/events';

    export default {
        props: ['id'],
        data() {
            return {
                modal: false,
            }
        },
        mounted() {
            this.$nextTick(function () {
                EventBus.$on('toggle-modal' + ':' + this.id, this.toggle);
            }.bind(this));
        },

        destroyed() {
            EventBus.$off('toggle-modal' + ':' + this.id, this.toggle);
        },

        methods: {

            toggle() {
                this.modal = !this.modal;
            },

        }

    }
</script>